module.exports = __webpack_public_path__ + "static/media/table-filter-dsc-icon.d22723ca.svg";